export const signUpApi = 'admin/auth/register'
export const signInApi = 'admin/auth/login'
export const emailSend = 'admin/auth/send-email'
export const changePassword = 'admin/auth/change-password'
export const logoutRoute = 'admin/auth/logout'
